export default __webpack_public_path__ + "static/media/neighborhood2.e748cdcc.jpg";